import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProviderType } from '../models/project-integration.model';
import { RequirementTypeOption } from '../models/requirement.model';

export interface CountByTypeResponse {
  type: string;
  count: number;
}

export interface SyncTypesResponse {
  providerType: ProviderType;
  host: string;
  added: string[];
  received: string[];
}

export interface DeleteByHostResponse {
  providerType: ProviderType;
  host: string;
  kept: string[];
}

@Injectable({ providedIn: 'root' })
export class RequirementTypeService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<RequirementTypeOption[]> {
    return this.http.get<RequirementTypeOption[]>(`${this.base}/${projectId}/requirement-types`);
  }

  countByType(projectId: string, type: string): Observable<CountByTypeResponse> {
    const params = new HttpParams().set('type', type);
    return this.http.get<CountByTypeResponse>(`${this.base}/${projectId}/requirements/count-by-type`, { params });
  }

  reorder(projectId: string, orderedIds: string[]): Observable<void> {
    return this.http.patch<void>(`${this.base}/${projectId}/requirement-types/reorder`, { orderedIds });
  }

  syncTypes(projectId: string, integrationId: string): Observable<SyncTypesResponse> {
    return this.http.post<SyncTypesResponse>(`${this.base}/${projectId}/integrations/${integrationId}/sync-types`, {});
  }

  deleteByHost(projectId: string, providerType: ProviderType, host: string): Observable<DeleteByHostResponse> {
    const params = new HttpParams().set('providerType', providerType).set('host', host);
    return this.http.delete<DeleteByHostResponse>(`${this.base}/${projectId}/requirement-types/by-host`, {
      params,
    });
  }
}
